import React, { Component } from "react";
import ActivityLog from "../audit-logs/audit-logs";

class OrganizationAuditLogs extends Component {
  state = {
    data: []
  }
  render() {
      return (
        <ActivityLog for="organization"/>
      )
  }
}
export default OrganizationAuditLogs;